<div class="background-image"></div>

@if (!sendEmail) {
  <div class="d-flex justify-content-center align-items-center" style="height: 100vh;">
    <div class="p-4 rounded w-100" style="max-width: 700px;">
      <h2 class="mb-3 middle-text text-white">Sie haben Ihre Zugangsdaten vergessen? Kein Problem!</h2>
      <form class="auth-input p-5" [formGroup]="form" (ngSubmit)="onSubmit()">
        <p class="fs-18 text-white">{{ 'Bitte geben Sie hier Ihre E-Mailadresse an. Sie erhalten in Kürze eine E-Mail von uns mit weiteren Anweisungen, wie Sie Ihr Kennwort zurücksetzen können.' | translate }}</p>

        <div class="mb-5">
          <label class="form-label text-white">{{ 'E-Mail' | translate }}</label>
          <input
            type="email"
            class="form-control"
            [class.is-invalid]="form.get('email')?.invalid && form.get('email')?.touched"
            [placeholder]="'E-Mail' | translate"
            formControlName="email"
          >
          @if (form.get('email')?.hasError('required') && form.get('email')?.touched) {
            <div class="invalid-feedback">
              {{ 'VALIDATION.EMAIL_REQUIRED' | translate }}
            </div>
          }
          @if (form.get('email')?.hasError('email') && form.get('email')?.touched) {
            <div class="invalid-feedback">
              {{ 'VALIDATION.EMAIL_INVALID' | translate }}
            </div>
          }
        </div>

        @if (errorMessage) {
          <div class="alert alert-danger mb-3">
            {{ errorMessage }}
          </div>
        }

        <div class="d-grid mb-5">
          <p-button
            styleClass="btn btn-primary"
            type="submit"
            [label]="'Absenden' | translate"
            [loading]="isLoading"
            [disabled]="isLoading"
          ></p-button>
        </div>

        <p class="fs-18 text-white">{{ 'Bitte überprüfen Sie Ihren Posteingang und gegebenenfalls auch Ihren Spam-Ordner.' | translate }}</p>

        <div class="text-center mt-3">
          <a routerLink="/" class="text-decoration-none"><u>{{ 'Zurück zum Login' | translate }}</u></a>
        </div>
      </form>
    </div>
  </div>
}

@if (sendEmail) {
  <div class="d-flex justify-content-center align-items-center" style="height: 100vh;">
    <div class="p-4 shadow text-center" style="max-width: 700px;">
      <div class="card-body">
        <div class="mb-4">
          <h2 class="mb-3 middle-text text-white">{{ 'E-Mail wurde versendet' | translate }}</h2>
        </div>

        <div class="mb-4">
          <p class="fs-24 text-white">{{ 'Wir haben Ihnen eine E-Mail zum Zurücksetzen Ihres Passworts gesendet.' | translate }}</p>
          <p class="fs-18 text-white">{{ 'Der darin enthaltene Link zum Zurücksetzen Ihres Kennworts ist aus Sicherheitsgründen nur in den nächsten 12 Stunden gültig.' | translate }}</p>
        </div>

        <i class="bi bi-envelope-check fs-1 text-primary mb-3"></i>

        <div class="border-top pt-3">
          <a routerLink="/" class="btn btn-primary"><u>{{ 'Zurück zum Login' | translate }}</u></a>
        </div>
      </div>
    </div>
  </div>
}
